import type { NetworkAccess, OptimisationPermissions, Viewer, ViewerId } from './types';

/** Access lists of the PUC EDM test network (prototype data, same personas as ref-network-general). */
export const NETWORK_ACCESS: NetworkAccess = {
    owners: ['Cecile ONNO'],
    editors: ['Équipe Études Réseaux'],
    readers: ['ON'],
};

export const VIEWERS: Record<ViewerId, Viewer> = {
    owner: {
        id: 'owner',
        label: 'Propriétaire',
        user: 'Cecile ONNO',
        roles: ['ON'],
        description: 'Cecile ONNO figure dans « Propriétaire » du réseau.',
    },
    write: {
        id: 'write',
        label: 'Écriture',
        user: 'Marc LEROY',
        roles: ['Équipe Études Réseaux'],
        description: 'Marc LEROY appartient au groupe « Équipe Études Réseaux », listé dans « Modifiable par ».',
    },
    read: {
        id: 'read',
        label: 'Lecture',
        user: 'Julie MARTIN',
        roles: ['ON'],
        description: 'Julie MARTIN appartient au groupe « ON », listé uniquement dans « Consultable par ».',
    },
};

export const VIEWER_IDS = Object.keys(VIEWERS) as ViewerId[];

export function isViewerId(value: string | null): value is ViewerId {
    return value !== null && (VIEWER_IDS as string[]).includes(value);
}

/** Mirrors Nemo `casl/ability.ts` for the network that owns the optimisations. */
export function computePermissions(access: NetworkAccess, viewer: Viewer): OptimisationPermissions {
    const hasRole = (roles: string[]) => viewer.roles.some((r) => roles.includes(r));
    const isOwner = access.owners.includes(viewer.user);
    const canWrite = isOwner || hasRole(access.editors);
    const canRead = canWrite || hasRole(access.readers);
    return { canRead, canWrite, canDelete: canWrite, canManageAccess: isOwner, canEdit: canWrite };
}
